import { TaskStatus, ExecTaskType } from '@/types/task';
import { computed } from '@vue/composition-api';
import { isInMiniProgram } from '@tencent/wphk-components-launch-weapp';
import { showLoading, hideLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@/utils/to';
import { execTask } from '@/store/task';
import { CustomException } from '@tencent/ppd-base-libs';

export const useTaskJumpBtn = (taskInfo) => {
  /** 是否展示跳转按钮 */
  const isShowJump = computed(() => {
    if (!taskInfo) return false;
    const { jumpInfo, status, finishCount, maxTimesPerStage } = taskInfo;
    // 有跳转配置
    const hasJumpConfig = !!jumpInfo;
    // 在任务期内
    const isTaskInProgress = status === TaskStatus.inProgress;
    // 未完成
    const isNotDone = finishCount < maxTimesPerStage;
    // 在小程序中时不为跳转小程序
    const isNotInMiniProgramJumpToMP = !(isInMiniProgram() && jumpInfo?.mode === 'mp');
    return hasJumpConfig && isTaskInProgress && isNotInMiniProgramJumpToMP && isNotDone;
  });
  /** 主动执行任务 */
  const beforeJump = async () => {
    if (!taskInfo) return;
    const { execConf } = taskInfo;
    // 主動執行任務
    if (execConf?.execTaskType === ExecTaskType.manual) {
      showLoading();
      const [err] = await to(execTask(execConf));
      hideLoading();
      // 执行失败也进行跳转
      if (err) {
        new CustomException(err, 'eStampExecManualTaskFail', '狂赏印页面执行主动任务失败');
      }
    }
  };
  return {
    isShowJump,
    beforeJump,
  };
};
